import { dataSchemaToTypes } from "../../core/common/dataSchemaToTypes";
export async function getTypesStringBySchema(ucDataSources, dataStub) {
  var _dataStub$parent;
  // const timeKey = 'getTypesStringBySchema';
  // console.time(timeKey);
  if (!ucDataSources) {
    return;
  }
  const sourceId = dataStub.id;
  const keySchemas = Object.values(ucDataSources).map(item => ({
    ...(item.schema || {}),
    id: item.id
  }));
  // const jsonSchemas = keySchemas.map(item => dataSchemaToJSONSchema(item, true));
  // const jstt = await window.xy_runtime_utils.loadJstt();
  // const typesStrings = await Promise.all(jsonSchemas.map(async (item) => {
  //   const res = await jstt.compile(item as any, item.title || 'unknown', { format: false, bannerComment: '' });
  //   const text = res.replaceAll('export ', '');
  //   return text;
  // }));
  const typesStrings = keySchemas.map(schema => dataSchemaToTypes(schema));
  if ((_dataStub$parent = dataStub.parent) !== null && _dataStub$parent !== void 0 && (_dataStub$parent = _dataStub$parent.schema) !== null && _dataStub$parent !== void 0 && _dataStub$parent.fields) {
    var _dataStub$parent2;
    typesStrings.push(`
interface IWujiSourceController {
  /**
   * 等待该数据源就绪
   */
  waitForReady():Promise<void>;
  /**
   * 该数据源是否就绪
   */
  isReady:boolean;
}
interface IWujiSourceControllers {
${(_dataStub$parent2 = dataStub.parent) === null || _dataStub$parent2 === void 0 || (_dataStub$parent2 = _dataStub$parent2.schema) === null || _dataStub$parent2 === void 0 || (_dataStub$parent2 = _dataStub$parent2.fields) === null || _dataStub$parent2 === void 0 ? void 0 : _dataStub$parent2.map(item => `  ${item.id}: IWujiSourceController;`).join('\n')}
}`);
  }
  typesStrings.push(messageTypeString);
  typesStrings.push($setTypeString);
  const vars = ['sources:IWujiSourceControllers', '$message:Message', '$set:VueSet'];
  const declareString = `
declare global {

${typesStrings.join('\n')}

${vars.map(item => `  var ${item};`).join('\n')}
  /**
   * 当前数据源实例
   */
  declare var source:(typeof data)["${sourceId}"];
};

export default {};
`;
  typesStrings.push(declareString);
  const dtsString = typesStrings.join('\n');
  // console.timeEnd(timeKey);
  // console.log(dtsString);
  return dtsString;
}
const messageTypeString = `
type ConfigOnClose = () => void;

interface MessageOptions {
  /**
   * content of the message
   */
  content: string;

  /**
   * time(seconds) before auto-dismiss, don't dismiss if set to 0
   * @default 3
   */
  duration?: number;

  /**
   * type of message
   */
  type?: 'success' | 'info' | 'warning' | 'error' | 'loading';

  /**
   * Customized Icon
   */
  icon?: string;

  /**
   * Specify a function that will be called when the message is closed
   */
  onClose?: ConfigOnClose;
  key?: string | number;
}

declare interface Message {
  success(content: MessageOptions): any;
  success(content: string, duration?: number, onClose?: ConfigOnClose): any;
  warning(content: MessageOptions): any;
  warning(content: string, duration?: number, onClose?: ConfigOnClose): any;
  warn(content: MessageOptions): any;
  warn(content: string, duration?: number, onClose?: ConfigOnClose): any;
  info(content: MessageOptions): any;
  info(content: string, duration?: number, onClose?: ConfigOnClose): any;
  error(content: MessageOptions): any;
  error(content: string, duration?: number, onClose?: ConfigOnClose): any;
  loading(content: MessageOptions): any;
  loading(content: string, duration?: number, onClose?: ConfigOnClose): any;
}
`;
const $setTypeString = `
type VueSet = (object: object | Array<any>, key: string | number, value: any) => any;`;
//# sourceMappingURL=codeTypes.js.map
